import React from "react";
import { Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider as ReduxProvider } from "react-redux";
import { history } from "./_helpers";
import { App } from "./app";
import configureStore from "./_redux/configureStore";
import { registerLicense } from "@syncfusion/ej2-base";
import "./i18n";
import "./styles.css";
import "./syncF.modules.css";
import { MuiToasterProvider } from "./_components/toaster/MuiToasterProvider";
registerLicense(
  "ORg4AjUWIQA/Gnt2UlhhQlVMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTX5adEBiXn5Xc3BQRWdf",
);
const store = configureStore();
const root = createRoot(document.getElementById("app"));
root.render(
   <MuiToasterProvider>
  <ReduxProvider store={store}>
    <Router history={history}>
      <App />
    </Router>
  </ReduxProvider>
  </MuiToasterProvider>,
);
